// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_ADD_CASE } from "./constants"
import { DAMAGE_CASE_DEFAULTS } from "./initialState"

export function addCase(caseId, lhoRef) {
  return {
    type: DAMAGE_CASE_ADD_CASE,
    data: { caseId, lhoRef },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_ADD_CASE:
      const { caseId, lhoRef } = action.data
      const newCase = { ...DAMAGE_CASE_DEFAULTS, lhoRef }
      return {
        ...state,
        unsentCases: { ...state.unsentCases, [caseId]: newCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/addCase.js